// side effect: remove feature highlights
import {removeHighlightFeatures} from '../slices/statusSlice';

let timeout = null;
export const highlightMiddleware = store => next => action => {
	if (action.type === 'status/setHighlightFeatures') {
		// to trigger css animation
		// first remove highlights
		store.dispatch(removeHighlightFeatures());
		// cleanup after some time in any case
		clearTimeout(timeout);
		timeout = setTimeout(() => store.dispatch(removeHighlightFeatures()), 1500);
		// then add highlights after dela
		requestAnimationFrame( () => next(action));
		return;
	}
	// eslint-disable-next-line consistent-return
	return next(action);
};
